import { removePaymentCardRoute, updateDefaultPaymentMethodRoute } from "@api-routes/payments";
import { useFetch } from "@common/hook/useFetch";
import { IError } from "itsf-ui-common";

interface IParams {
    accountId: string;
    successCallback(): void;
    errorCallback?(error: IError): void;
}

export const usePaymentCardList = (props: IParams) => {
    const { accountId, successCallback, errorCallback } = props;
    const [cardState, { deleteCall, put }] = useFetch();

    const removeCard = (cardId: number) => {
        deleteCall<boolean>(removePaymentCardRoute(cardId, accountId), {
            forwardError: true,
        })
            .then((result) => {
                if (result) {
                    successCallback();
                }
            })
            .catch(errorCallback);
    };

    const setDefaultCard = (cardId: number) => {
        put<boolean>(updateDefaultPaymentMethodRoute(cardId, accountId), { forwardError: true })
            .then((result) => {
                if (result) {
                    successCallback();
                }
            })
            .catch(errorCallback);
    };

    const retryCard = () => {
        successCallback();
    };

    return {
        cardState,
        removeCard,
        retryCard,
        setDefaultCard,
    };
};
